import React, {useEffect} from "react";
import './App.css';
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Checkout from "./components/Checkout";
import Login from "./components/Login";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Payment from "./components/Payment";
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js'
import Orders from "./components/Orders";

const promise = loadStripe("pk_test_51IglljGH9YwMTbF5h9Zeydiizr37A4EJsoDqKlvHNhxIX9trFtFb2xKj4ZK9etBY4gPVaQOa0el5bWlcual5iNH100J4IeozIm");
const App = () => {
  
  const [{user}, dispatch] = useStateValue();
  useEffect(() => {
    auth.onAuthStateChanged((authUser) =>{
      if(authUser){
        dispatch({
          type: "SET_USER",
          user: authUser
        });
      } else {
        dispatch({
          type: "SET_USER",
          user: null
        });
      }
    });
  }, [dispatch])
  return (
    <Router>
      <div className="App">
      
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/checkout">
            <Header />
            <Checkout />
          </Route>
          <Route path="/orders">
            <Header />
            <Orders />
          </Route>
          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
               <Payment />
            </Elements>
          </Route>
          <Route path="/">
            <Header />
            <Home />
          </Route>
       </Switch>
     
      </div>

    </Router>
    
  );
}

export default App;
